<div
  class="chat-window"
  [class.chat-window--minimized]="!_isOpen()"
  [class.chat-window--expanded]="_isExpanded()"
>
  <!-- Title bar -->
  <div class="chat-window-titlebar" (click)="_onMinimize()">
    <span class="chat-window-title">{{ windowState().title }}</span>

    <div class="chat-window-actions" (click)="$event.stopPropagation()">
      @if (_hasMessages()) {
        <div class="menu-wrapper">
          <button
            class="titlebar-btn"
            (click)="_toggleMenu()"
            [title]="chatWordings.options()"
          >
            <i class="myre-icon-menu"></i>
          </button>

          @if (_showMenu()) {
            <div class="menu-backdrop" (click)="_closeMenu()"></div>
            <div class="menu-dropdown">
              <button class="menu-item" (click)="_onCopyMarkdown()">
                <i class="myre-icon-copy"></i>
                {{ chatWordings.copyAsMarkdown() }}
              </button>
              <button class="menu-item menu-item--danger" (click)="_onDelete()">
                <i class="myre-icon-delete"></i>
                {{ chatWordings.deleteThread() }}
              </button>
            </div>
          }
        </div>
      }

      <button
        class="titlebar-btn"
        (click)="_onMinimize()"
        [title]="chatWordings.minimize()"
      >
        <i class="myre-icon-subtract"></i>
      </button>
      <button
        class="titlebar-btn"
        (click)="_onToggleExpand()"
        [title]="
          _isExpanded() ? chatWordings.collapse() : chatWordings.expand()
        "
      >
        <span class="titlebar-icon">{{
          _isExpanded() ? '&#x2199;' : '&#x2197;'
        }}</span>
      </button>
      <button
        class="titlebar-btn"
        (click)="_onClose()"
        [title]="chatWordings.close()"
      >
        <i class="myre-icon-close"></i>
      </button>
    </div>
  </div>

  <!-- Chat content -->
  <div class="chat-window-body">
    <app-chat
      [visible]="_isOpen()"
      [apiConfig]="apiConfig()"
      [welcomeIconUrl]="welcomeIconUrl()"
      [welcomeIcon]="welcomeIcon()"
      [initialSessionId]="windowState().initialSessionId"
      (titleChanged)="_onTitleChanged($event)"
      (statusChanged)="_onStatusChanged($event)"
    />
  </div>
</div>
